/**
 * Static file names used across the application.
 * Use these when the file name does NOT depend on any dynamic data
 * (e.g., student name, date range, etc.)
 *
 * Example usage:
 *   const fileName = FILENAMES.SKILLPASSPORT;
 */
export const FILENAMES = {
    SKILLPASSPORT: 'skill_passport'
};

/**
 * Dynamic file name generator functions.
 * Use these when the file name depends on runtime data
 * (e.g., student name, selected date range, etc.)
 *
 * Each key maps to a function that returns a formatted file name string.
 *
 * Example usage:
 *   const fileName = DYNAMICFILENAMEGENERATORS.RESUME("John Doe");
 *   // => "John Doe Resume"
 */
export const DYNAMICFILENAMEGENERATORS = {
    RESUME: (studentName) => `${studentName} Resume`, // Example: "John Doe Resume"
    SKILLPASSPORT: (studentName) => `${studentName} Skill Passport`, // Example: "John Doe Skill Passport"
    ATTENDANCE: (fromDate, toDate) => `attendance_${fromDate}_${toDate}` // Example: "attendance_2024-01-01_2024-01-31"
};